import { isEmpty } from 'lodash-es';
import { GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import MarkdownEditor from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/markdown/markdown_editor.vue?vue3';
import EditorModeSwitcher from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/markdown/editor_mode_switcher.vue?vue3';
import { EDITING_MODE_MARKDOWN_FIELD, EDITING_MODE_CONTENT_EDITOR } from '~/vue_shared/constants';
import { s__ } from '~/locale';
import namespacePathsQuery from '~/work_items/graphql/namespace_paths.query.graphql';
const RESTRICTED_TOOLBAR_ITEMS = [
    'full-screen'
];
const SWITCHER_VALUE_MARKDOWN = 'markdown';
const SWITCHER_VALUE_RICH_TEXT = 'richText';
export default {
    name: 'WorkplanEditor',
    components: {
        EditorModeSwitcher,
        GlButton,
        MarkdownEditor
    },
    inject: [
        'fullPath'
    ],
    props: {
        savedContent: {
            type: String,
            required: true
        },
        draftContent: {
            type: String,
            required: true
        },
        isSaving: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'save',
        'cancel-edit',
        'draft-change'
    ],
    data () {
        return {
            tmpContent: this.draftContent || this.savedContent,
            markdownPaths: {},
            editorMode: EDITING_MODE_MARKDOWN_FIELD,
            formFieldProps: {
                id: 'workplan',
                name: 'workplan',
                'aria-label': s__('AgentPlan|Workplan')
            }
        };
    },
    computed: {
        areMarkdownPathsLoaded () {
            return !isEmpty(this.markdownPaths);
        },
        nextEditorMode () {
            return this.editorMode === EDITING_MODE_MARKDOWN_FIELD ? EDITING_MODE_CONTENT_EDITOR : EDITING_MODE_MARKDOWN_FIELD;
        },
        editorSwitcherValue () {
            return this.editorMode === EDITING_MODE_MARKDOWN_FIELD ? SWITCHER_VALUE_MARKDOWN : SWITCHER_VALUE_RICH_TEXT;
        }
    },
    apollo: {
        markdownPaths: {
            query: namespacePathsQuery,
            variables () {
                return {
                    fullPath: this.fullPath
                };
            },
            update (data) {
                return data?.namespace?.markdownPaths || {};
            },
            skip () {
                return !this.fullPath;
            }
        }
    },
    methods: {
        toggleEditorMode () {
            this.$refs.markdownEditor?.onEditingModeChange(this.nextEditorMode);
        },
        onEditorModeSynced (mode) {
            this.editorMode = mode;
        },
        cancelEdit () {
            this.$emit('cancel-edit');
        },
        savePlan () {
            this.$emit('save', this.tmpContent?.trim() || '');
        },
        handleInput (value) {
            this.tmpContent = value;
            this.$emit('draft-change', value);
        }
    },
    RESTRICTED_TOOLBAR_ITEMS,
    EDITING_MODE_MARKDOWN_FIELD,
    EDITING_MODE_CONTENT_EDITOR
};
